type CustomPropertyInputProps = {
  id: string;
  type: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
};

export const CustomPropertyInput = ({
  id,
  type,
  placeholder,
  value,
  onChange,
  required,
}: CustomPropertyInputProps) => (
  <div className="container__input">
    <input
      id={id}
      type={type}
      className="input__generic"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      required={required}
    />
  </div>
);
